/* eslint-disable import/no-cycle */
import { MdCheckBox, MdTextFields, MdToggleOn, MdVideoLibrary } from 'react-icons/md';
import { RiFileUploadFill } from 'react-icons/ri';
import { QUESTIONNAIRE_ELEMENT_TYPE } from '../../questionnaireTemplate.enums';
import { QuestionnaireElementSchema } from '../../questionnaireTemplate.types';
import { MAX_BRANCH_DEPTH } from '../utils/constants';

import { FreeForm } from '../builderElements/freeForm/FreeForm';
import { YesNo } from '../builderElements/yesNo/YesNo';
import { YesNoWithImage } from '../builderElements/yesNo/YesNoWithImage';
import { MultiChoice } from '../builderElements/multiChoice/MultiChoice';
import { MultiChoiceWithImage } from '../builderElements/multiChoice/MultiChoiceWithImage';
import { VideoResponse } from '../builderElements/videoResponse/VideoResponse';
import { DocumentUpload } from '../builderElements/documentUpload/DocumentUpload';

export const formElementSchema: Record<QUESTIONNAIRE_ELEMENT_TYPE, QuestionnaireElementSchema> = {
  [QUESTIONNAIRE_ELEMENT_TYPE.YESNO]: {
    questionType: QUESTIONNAIRE_ELEMENT_TYPE.YESNO,
    component: YesNo,
    label: 'yesno.label',
    chipLabel: 'yesno.chipLabel',
    icon: MdToggleOn,
    enabled: true,
    branches: ['yes', 'no'],
    isBranchDisabled: true,
    colors: {
      bg: 'rgba(255, 180, 135, 0.3)',
      text: 'rgba(255, 93, 64, 1)',
    },
    withImage: false,
    maxBranchChildrenCount: MAX_BRANCH_DEPTH,
  },
  [QUESTIONNAIRE_ELEMENT_TYPE.YESNO_WITH_IMAGE]: {
    questionType: QUESTIONNAIRE_ELEMENT_TYPE.YESNO_WITH_IMAGE,
    component: YesNoWithImage,
    label: 'yesnoWithImage.label',
    chipLabel: 'yesnoWithImage.chipLabel',
    icon: MdToggleOn,
    enabled: false,
    branches: ['yes', 'no'],
    isBranchDisabled: true,
    colors: {
      bg: 'rgba(255, 180, 135, 0.3)',
      text: 'rgba(255, 93, 64, 1)',
    },
    withImage: true,
    maxBranchChildrenCount: MAX_BRANCH_DEPTH,
  },
  [QUESTIONNAIRE_ELEMENT_TYPE.MULTI_CHOICE]: {
    questionType: QUESTIONNAIRE_ELEMENT_TYPE.MULTI_CHOICE,
    component: MultiChoice,
    label: 'multiChoice.label',
    chipLabel: 'multiChoice.chipLabel',
    icon: MdCheckBox,
    enabled: true,
    colors: {
      bg: 'rgba(33, 150, 243, 0.15)',
      text: 'rgba(33, 150, 243, 1)',
    },
    withImage: false,
  },
  [QUESTIONNAIRE_ELEMENT_TYPE.MULTI_CHOICE_WITH_IMAGE]: {
    questionType: QUESTIONNAIRE_ELEMENT_TYPE.MULTI_CHOICE_WITH_IMAGE,
    component: MultiChoiceWithImage,
    label: 'multiChoiceWithImage.label',
    chipLabel: 'multiChoiceWithImage.chipLabel',
    icon: MdCheckBox,
    enabled: true,
    colors: {
      bg: 'rgba(33, 150, 243, 0.15)',
      text: 'rgba(33, 150, 243, 1)',
    },
    withImage: true,
  },
  [QUESTIONNAIRE_ELEMENT_TYPE.FREE_FORM]: {
    questionType: QUESTIONNAIRE_ELEMENT_TYPE.FREE_FORM,
    component: FreeForm,
    label: 'freeform.label',
    chipLabel: 'freeform.chipLabel',
    icon: MdTextFields,
    enabled: true,
    colors: {
      bg: 'rgba(243, 232, 255, 1)',
      text: 'rgba(123, 83, 217, 1)',
    },
    withImage: false,
  },
  [QUESTIONNAIRE_ELEMENT_TYPE.DOCUMENT_UPLOAD]: {
    questionType: QUESTIONNAIRE_ELEMENT_TYPE.DOCUMENT_UPLOAD,
    component: DocumentUpload,
    label: 'documentUpload.label',
    chipLabel: 'documentUpload.chipLabel',
    icon: RiFileUploadFill,
    enabled: true,
    colors: {
      bg: 'rgba(243, 244, 251, 1)',
      text: 'rgba(38, 61, 186, 1)',
    },
    withImage: false,
  },
  [QUESTIONNAIRE_ELEMENT_TYPE.VIDEO_RESPONSE]: {
    questionType: QUESTIONNAIRE_ELEMENT_TYPE.VIDEO_RESPONSE,
    component: VideoResponse,
    label: 'videoResponse.label',
    chipLabel: 'videoResponse.chipLabel',
    icon: MdVideoLibrary,
    enabled: true,
    colors: {
      bg: 'rgba(240, 255, 244, 1)',
      text: 'rgba(56, 161, 105, 1)',
    },
    withImage: false,
  },
};
